import { token } from '@terra/ui-styled-system';

export function getProxyModifiedRowBackground(): string {
  return `${token('colors.orange.9')}20`;
}

export function getProxyModifiedIndicatorColor(): string {
  return token('colors.orange.9');
}
